module.exports = __webpack_public_path__ + "static/img/11bac.81195bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/11bac.jpg
// module id = urM3
// module chunks = 1